var render, staticRenderFns
import script from "./add_position.vue?vue&type=script&lang=js"
export * from "./add_position.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4628c3e8')) {
      api.createRecord('4628c3e8', component.options)
    } else {
      api.reload('4628c3e8', component.options)
    }
    
  }
}
component.options.__file = "found/views/mdm/views/position_information/add_position/add_position.vue"
export default component.exports